import { render, staticRenderFns } from "./EditMultiRecord.vue?vue&type=template&id=1adcc754&scoped=true"
import script from "./EditMultiRecord.vue?vue&type=script&lang=js"
export * from "./EditMultiRecord.vue?vue&type=script&lang=js"
import style0 from "./EditMultiRecord.vue?vue&type=style&index=0&id=1adcc754&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adcc754",
  null
  
)

export default component.exports